import { Link, useForm } from '@inertiajs/react'
import Layout from '../Layout'

interface Account {
  id: number
  name: string
  slug: string
}

interface Category {
  id: number
  name: string
}

interface Props {
  categories: Category[]
  account: Account
  permissions?: {
    can_manage_categories: boolean
  }
  can_manage?: boolean
  can_delete?: boolean
}

export default function CategoriesIndex({ categories, account, permissions, can_manage, can_delete }: Props) {
  const { delete: destroy } = useForm()

  const handleDelete = (id: number) => {
    if (confirm('¿Estás seguro de eliminar esta categoría?')) {
      destroy(`/${account.slug}/categories/${id}`)
    }
  }

  return (
    <Layout account={account} permissions={permissions}>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-[#202020]">Categorías</h1>
        {can_manage && (
          <Link
            href={`/${account.slug}/categories/new`}
            className="bg-[#FFC107] text-[#202020] px-4 py-2 rounded hover:bg-[#e6ad06] transition-colors font-semibold"
          >
            Nueva Categoría
          </Link>
        )}
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nombre</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Acciones</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {categories.map((category) => (
              <tr key={category.id}>
                <td className="px-6 py-4">{category.name}</td>
                <td className="px-6 py-4 space-x-2">
                  {can_manage && (
                    <Link
                      href={`/${account.slug}/categories/${category.id}/edit`}
                      className="text-[#55ACEE] hover:underline"
                    >
                      Editar
                    </Link>
                  )}
                  {can_delete && (
                    <button
                      onClick={() => handleDelete(category.id)}
                      className="text-red-600 hover:underline"
                    >
                      Eliminar
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Layout>
  )
}
